<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-07-28
-->

<script lang="ts" setup>
import { useI18n } from '#imports';

const { t } = useI18n();
</script>

<template>
  <section class="relative w-full overflow-hidden border-b border-gray-200/50 bg-bg-gray py-12 md:py-16">
    <div class="bg-radial-gradient absolute inset-0 from-brand-blue/5 via-transparent to-transparent opacity-60"></div>
    <div class="relative mx-auto max-w-360 px-6 md:px-20">
      <!-- Breadcrumbs -->
      <nav class="flex items-center gap-2 text-xs font-semibold tracking-wider text-slate-500 uppercase">
        <NuxtLink to="/" class="transition hover:text-brand-blue">
          {{ t('home') }}
        </NuxtLink>
        <span class="text-slate-400">/</span>
        <span class="text-slate-800">{{ t('courses.liveClasses') }}</span>
      </nav>

      <h1 class="mt-4 font-sans text-3xl font-extrabold tracking-tight text-gray-900 md:text-5xl">
        {{ t('courses.liveClasses') }}
      </h1>
      <p class="mt-3 max-w-3xl text-sm leading-relaxed text-gray-600 md:text-base">
        {{ t('courses.liveClassesDesc') }}
      </p>
    </div>
  </section>
</template>
